import { createContext } from "react";
import { SocketsContext } from './interface';

export const SocketContext = createContext<SocketsContext>({} as SocketsContext);